export const otherProductReducer = (state, action) => {
  switch (action.type) {
    case "SET_PRODUCT_DETAIL":
      return {
        ...state,
        productDetails: {
          ...state.productDetails,
          gid: action.payload.gid,
          pid: action.payload.pid,
          name: action.payload.name,
          type: action.payload.type,
          price: action.payload.price,
          billingcycle: action.payload.billingcycle,
        },
      };
    case "SET_PRICE_AND_CYCLE":
      return {
        ...state,
        productDetails: {
          ...state.productDetails,
          price: action.payload.price,
          billingcycle: action.payload.billingcycle,
        },
      };
    case "SET_PRODUCT_PRICE":
      return {
        ...state,
        price: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
